import './hierarchy-toolbar.scss';

const HierarchyToolbarBottom = (props: any) => {
  return  (
    <div className="hierarchy-toolbar toolbar-bottom">
      <div className="hierarchy-toolbar-box">
        <div className='default-buttons'>
          {
            props.isEditing ? <></> :
            <>
              <button onClick={props.addCustomSubtopic}>+ Custom Subtopic</button>
              <button onClick={props.addGeneratedSubtopic}>+ Generated Subtopic</button>
            </>
          }
        </div>
      </div>
    </div>
  )
}

export default HierarchyToolbarBottom;